/**
 * Common modal states used across the application.
 */
export enum ModalState {
  IDLE = "idle",
  LOADING = "loading",
  PROCESSING = "processing",
  VALIDATING = "validating",
  RUNNING = "running",
  GENERATING = "generating",
  SUCCESS = "success",
  ERROR = "error",
}

export enum HeroKind {
  IMAGE = "image",
  LOTTIE = "lottie",
}
